export const SITE_TYPE = "CAFE24";

export const CAFE24_PAGE = {
  LOGIN: { target: `${SITE_TYPE}:LOGIN`, url: "/member/login.html" },
  SIGNUP: { target: `${SITE_TYPE}:SIGNUP`, url: "/member/join.html" },
  SIGNUP_COMPLETE: {
    target: `${SITE_TYPE}:SIGNUP_COMPLETE`,
    url: "/member/join_result.html",
  },
  ORDER_SUCCESS: {
    target: `${SITE_TYPE}:ORDER_SUCCESS`,
    url: "/order/order_result.html",
  },
  MY_PAGE: { target: `${SITE_TYPE}:MY_PAGE`, url: "/myshop/index.html" },
  CART: { target: `${SITE_TYPE}:CART`, url: "/order/basket.html" },
  GUIDE: { target: `${SITE_TYPE}:GUIDE`, url: "/shopinfo/guide.html" },
  FIND_ID: {
    target: `${SITE_TYPE}:FIND_ID`,
    url: "/member/id/find_id.html",
  },
  FIND_PASSWORD: {
    target: `${SITE_TYPE}:FIND_PASSWORD`,
    url: "/member/passwd/find_passwd_info.html",
  },
  MEMBER_MODIFY: {
    target: `${SITE_TYPE}:MEMBER_MODIFY`,
    url: "/member/modify.html",
  },
  CHECK_ORDER: {
    target: `${SITE_TYPE}:CHECK_ORDER`,
    url: "/myshop/order/list.html",
  },
  WISH_LIST: {
    target: `${SITE_TYPE}:WISH_LIST`,
    url: "/myshop/wish_list.html",
  },
  CHECK_MILEAGE: {
    target: `${SITE_TYPE}:CHECK_MILEAGE`,
    url: "/myshop/mileage/historyList.html",
  },
  COUPON: {
    target: `${SITE_TYPE}:COUPON`,
    url: "/myshop/coupon/coupon.html",
  },
  BOARD_LIST: {
    target: `${SITE_TYPE}:BOARD_LIST`,
    url: "/myshop/board_list.html",
  },
  DELIVERY_ADDR_LIST: {
    target: `${SITE_TYPE}:DELIVERY_ADDR_LIST`,
    url: "/myshop/addr/list.html",
  },
  REGULAR_DELIVERY_LIST: {
    target: `${SITE_TYPE}:REGULAR_DELIVERY_LIST`,
    url: "/myshop/regular_delivery.html",
  },
  CATEGORY: {
    target: `${SITE_TYPE}:CATEGORY`,
    url: "/category",
  },
  PRODUCT: {
    target: `${SITE_TYPE}:PRODUCT`,
    url: "/product",
  },
};
